module.exports = __webpack_public_path__ + "static/img/manual-33.bf43bb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-33.png
// module id = 9xta
// module chunks = 4